module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAx0lEQVQ4jbWTMQ5BQRCGPyIKIkQhaldwBpWTuIEjKFQKiYJOopSI7pUKDSegEVGo1JqVifdkTN6zbwt/spvZ/LPfTmZ3cfk1cM5hR4m3RsCRbE2znASwA7Y/AGMfQFQB+sY/eyr7AjSBmfEXIYBrDAlSMSBZGuns0BU0gKHZtAfWcTwHVsqriqcBZaBrADcVn4BIreu2B3eg988epEpX0AKWJmkDTPICnsDB+JeQCh4pt+BVAmgDHc9B8sh0Tk2mgnzm0FM/Al4FfVt12ZFJMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/返校预约.png
// module id = WGwM
// module chunks = 1